import styled from 'styled-components';

export const IdentificationCardImagePod = styled.img`
  max-height: 35rem;
  width: 100%;
`;
